const checkoutContents = `Checkout <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.7071 8.70711C22.0976 8.31658 22.0976 7.68342 21.7071 7.2929L15.3431 0.928934C14.9526 0.538409 14.3195 0.538409 13.9289 0.928933C13.5384 1.31946 13.5384 1.95262 13.9289 2.34315L19.5858 8L13.9289 13.6569C13.5384 14.0474 13.5384 14.6805 13.9289 15.0711C14.3195 15.4616 14.9526 15.4616 15.3431 15.0711L21.7071 8.70711ZM21 7L8.74228e-08 7L-8.74228e-08 9L21 9L21 7Z" fill="#003648"/></svg>`
const buyNowContents = `${emptyCartCtaText} <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.7071 8.70711C22.0976 8.31658 22.0976 7.68342 21.7071 7.2929L15.3431 0.928934C14.9526 0.538409 14.3195 0.538409 13.9289 0.928933C13.5384 1.31946 13.5384 1.95262 13.9289 2.34315L19.5858 8L13.9289 13.6569C13.5384 14.0474 13.5384 14.6805 13.9289 15.0711C14.3195 15.4616 14.9526 15.4616 15.3431 15.0711L21.7071 8.70711ZM21 7L8.74228e-08 7L-8.74228e-08 9L21 9L21 7Z" fill="#003648"/></svg>`

class CartPopup extends HTMLElement {
  constructor() {
    super();

    this.focusOnCloseEl = null
    this.isOpen = false
    this.timeout = null
    this.buttonType = 'checkout'
    this.cart = {}

    this.overlay = ce({
      classname: 'cart-popup__overlay',
      listeners: {
        'click': () => this.close()
      }
    })
    
    this.titleEl = ce({
      type: 'h1',
      classname: 'cart-popup__title',
      contents: 'Your Cart',
      props: {
        tabIndex: 0
      }
    })

    this.closeButtonEl = ce({
      type:'button',
      classname: 'cart-popup__close',
      props: {
        'aria-label': 'close',
      },
      listeners: {
        click: () => this.close()
      }
    })

    this.errorEl = ce({
      classname: 'cart-popup__error'
    })

    this.loaderEl = ce({
      classname: 'cart-popup__drawer-loader',
    })
    this.loaderEl.innerHTML = '<svg class="ring" viewBox="25 25 50 50" stroke-width="4"><circle cx="50" cy="50" r="20" /></svg>'

    this.itemsContainerEl = ce({
      classname: 'cart-popup__items',
      contents: [this.loaderEl]
    })

    this.itemsOuterEl = ce({
      classname: 'cart-popup__items-outer',
      contents: [this.itemsContainerEl, this.loaderEl]
    })

    this.subtotalLabelEl = ce({
      classname: 'cart-popup__subtotal-label',
      contents: 'Subtotal'
    })

    this.subtotalValueEl = ce({
      classname: 'cart-popup__subtotal-amount',
      contents: '$599.00'
    })

    this.subtotalContainerEl = ce({
      classname: 'cart-popup__subtotal',
      contents: [this.subtotalLabelEl, this.subtotalValueEl]
    })

    this.checkoutButtonEl = ce({
      type: 'button',
      classname: 'cart-popup__button',
      listeners:{
        click: () => this.handleButtonClick()
      }
    })
    this.checkoutButtonEl.innerHTML = checkoutContents

    this.sparkleEls = [1,2,3,4,5].map(i=>{
      const sparkle = ce({classname: [`cart-popup__sparkle`, `cart-popup__sparkle-${i}`]})
      sparkle.innerHTML = '<svg  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23 26" enable-background="new 0 0 23 26" xml:space="preserve"><path fill="#FEBA00" d="M23,13c-5.9,1.1-10.5,6.4-11.5,13c-1-6.7-5.6-11.9-11.5-13c5.9-1.2,10.5-6.4,11.5-13C12.5,6.6,17.1,11.9,23,13L23,13z"/></svg>'
      return sparkle
    })

    this.popupEl = ce({
      type: 'aside',
      classname: 'cart-popup__drawer',
      contents: [this.titleEl, this.closeButtonEl, this.errorEl, this.itemsOuterEl, this.subtotalContainerEl, this.checkoutButtonEl, ...this.sparkleEls]
    })

    this.iconEl = ce({
      type: 'button',
      classname: 'cart-popup__icon',
      listeners: { click: () => this.toggle(this.iconEl) }
    })
    
  }

  connectedCallback(){
    this.append(this.iconEl)
    this.populate()

    window.addEventListener('keydown', (evt) => {
      if(evt.code === 'Escape'){
        this.close()
      }
    })
  }

  setIsLoading(isLoading = true){
    if(isLoading){
      this.popupEl.classList.add('is-loading')
      this.checkoutButtonEl.disabled = true
    } else{
      this.popupEl.classList.remove('is-loading')
      this.checkoutButtonEl.disabled = false
    }
  }

  createCartItem({id, image, title, options, price, handle, quantity}){
    const isDeposit = handle.includes('deposit')

    const imageEl = ce({
      type: 'img',
      classname: 'cart-popup__item-image',
      props: {
        src: image
      }
    })
  
    const imageContainerEl = ce({
      classname: 'cart-popup__item-image-container',
      contents: imageEl
    })
  
    const titleEl = ce({
      classname: 'cart-popup__item-title',
      contents: title
    })
  
    const optionEls = options 
    .filter(o => !o.value.toLowerCase().includes('default'))
    .map(option => {
     const shippingTitle = option.name.replace('Shipping Window', handle.includes('membership') ? 'Activates' : 'Shipping')
     return ce({
        classname: 'cart-popup__item-option cart-popup__item-detail',
        contents: `${shippingTitle}: ${option.value}`
      })
    })

    const quantityOptionEl = handle.includes('membership') ? ce({
      classname: 'cart-popup__item-price cart-popup__item-detail',
      contents: `Quantity: ${quantity}`
    }) : ''
  
    const priceEl = ce({
      classname: 'cart-popup__item-price cart-popup__item-detail',
      contents: price === 0 ? 'Free' : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price/100)
    })
    
  
    const optionsEl = ce({
      contents: [...optionEls, quantityOptionEl, priceEl]
    })

    const quantityInputEl = ce({
      type: 'input',
      props: {
        type: 'number',
        min: 0,
        max: isDeposit ? 1 : 99,
        value: quantity,
        'aria-label': 'Quantity'
      },
      listeners: {
        input: handleQuantityUpdate
      }
    })

    const updateEl = handle.includes('membership') ? '' : ce({
      type: "button",
      classname: 'cart-popup__item-update cart-popup__item-detail',
      contents: 'Update',
      listeners: {
        click: () => this.updateQuantity({id, currentQuantity: quantity, newQuantity: quantityInputEl.valueAsNumber, options})
      }
    })

    const quantityEl = handle.includes('membership') ? '' : ce({
      classname: 'cart-popup__item-quantity',
      contents: [quantityInputEl, updateEl]
    }) 


    const metadataEl = ce({
      classname: 'cart-popup__metadata', 
      contents: [optionsEl, quantityEl]
    })

    const detailsEl = ce({
      classname: 'cart-popup__item-details',
      contents: [titleEl, metadataEl]
    })

  
    const containerEl = ce({
      classname: 'cart-popup__item',
      contents: [imageContainerEl, detailsEl]
    })

    function handleQuantityUpdate(evt){
      let newQuantity = evt.target.value

      if(isDeposit){
        newQuantity = Math.min(newQuantity, 1)
      }

      if(parseInt(newQuantity) !== parseInt(quantity)){
        updateEl.classList.add('is-visible')
        updateEl.disabled = false
      } else{
        updateEl.classList.remove('is-visible')
        updateEl.disabled = true
      }
    }

    return containerEl
  }

  addQuantity({id, additional, associatedMembership}){
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items:[
          {
            id: id.toString(), 
            quantity: additional
          },
          ...(associatedMembership ? [{
            id: associatedMembership.id.toString(), 
            quantity: additional,
            selling_plan: associatedMembership.selling_plan_allocation.selling_plan.id
          }] : [])
        ]
      })
    })
    .then(res => res.json())
    .then(res=>{
      if(res.status){
        this.setError(res.description || 'Unable to update cart, please reload page and try again')
        this.setIsLoading(false)
      } else {
        this.populate()
      }
    }).catch((error) => {
      this.setIsLoading(false)
      this.setError(error.description || 'Unable to update cart, please reload page and try again')
    })
  }

  subtractQuantity({id, newQuantity, subtraction, associatedMembership}){
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates:{
          [id]: newQuantity,
          ...(associatedMembership ? {[associatedMembership.id]: associatedMembership.quantity - subtraction} : {}) 
        }
      })
    })    
    .then(()=>{
      this.populate()
    })
    .catch((error) => {
      this.setIsLoading(false)
      this.setError(error.description || 'Unable to update cart, please reload page and try again')
    })
  }
  
  updateQuantity({id, currentQuantity, newQuantity, options}){
    this.setError(false)
    this.setIsLoading(true)
    const associatedMembership = this.cart.items.filter(item => {
      return item.handle.includes('membership')
    })?.[0]

    if(newQuantity - currentQuantity > 0){
      this.addQuantity({id, additional: newQuantity - currentQuantity, associatedMembership})
    } else {
      this.subtractQuantity({id, newQuantity, subtraction: currentQuantity - newQuantity, associatedMembership})
    }
  }

  synchronize(){
    return new Promise(async (resolve, reject) => {
      await fetch('/cart.js')
      .then(res=> res.json())
      .then(res=> {
        this.cart = res
      })
      .catch(err => {
        this.setIsLoading(false)
        console.log(err)
      })

      if(!this.cart?.items?.length){
        resolve('no_changes')
        return
      }
      const displays = this.cart.items.filter(i=>i.handle.includes('display') && !i.handle.includes('deposit'))
      const memberships = this.cart.items.filter(i=>i.handle.includes('membership'))[0]
      const extraneousMemberships = this.cart.items.filter(i=>i.handle.includes('membership')).filter((m,i) => i > 0)
      const numberOfDisplays = displays.reduce((acc, curr) => {
        acc += curr.quantity
        return acc
      }, 0)
      const numberOfMemberships = memberships?.quantity || 0
      let updates = false

      const res = await fetch('/products/hearth-display.js')
      const productInfo = await res.json()
      const productVariantsById = productInfo?.variants?.reduce((acc, curr) =>{
        acc[curr.id] = curr
        return acc
      },{})

      displays.forEach(display => {
        const isAvailable = productVariantsById[display.variant_id].available
        if(!isAvailable){
          updates = updates || {}
          updates[display.variant_id] = 0
        }
      })

      // There are extraneous memberships. Remove them.
      if(extraneousMemberships.length){
        updates = updates || {}

        extraneousMemberships.forEach(membership => {
        updates[membership.variant_id] = 0
        })
      }

      // We dont have a membership for every display in the cart
      if(memberships && numberOfMemberships !== numberOfDisplays){
        updates = updates || {}
        updates[memberships.variant_id] = numberOfDisplays
      }

      if(Object.keys(updates).length){
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        })    
        .then(()=>{
          resolve('changes')
        })
        .catch((error) => {
          fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST'
          }) 
          .then(()=>{
            this.setIsLoading(false)
            this.setError('Sorry, we ran into an issue and had to clear your cart. Please try again.')
            this.populate()
            resolve('error')
          })
        })
      } else {
        resolve('no_changes')
      }
    })
  }

  refresh(){
    this.setIsLoading(true)
    return this.synchronize().then(()=>this.populate())
  }

  setError(message){
    if(message) {
      this.errorEl.innerHTML = message
      this.errorEl.classList.add('is-visible')
    } else {
      this.errorEl.innerHTML = 'message'
      this.errorEl.classList.remove('is-visible')
    }
  }

  setButton(state = 'checkout'){
    if(state === 'checkout'){
      this.buttonType = state
      this.checkoutButtonEl.innerHTML = checkoutContents
      this.checkoutButtonEl.href = ''
    } else if(state === 'buy') {
      this.buttonType = state
      this.checkoutButtonEl.innerHTML = buyNowContents
    }
  }

  handleButtonClick(){
    if(this.buttonType === 'checkout'){
      this.setIsLoading(true)
      return this.synchronize().then((res)=>{
        if(res === 'changes'){
          this.populate()
        } else {
          location.href = '/checkout'
        }
      })
    } else {
      location.href = emptyCartCtaUrl
    }
  }

  populate(){
    this.setIsLoading(true)
    fetch('/cart.js')
    .then(res=> res.json())
    .then(res=> {
      this.cart = res
      this.sparkleEls.forEach(sparkle=>sparkle.classList.add('is-sparkly'))
      this.itemsContainerEl.innerHTML = ''
      this.setIsLoading(false)
    
      if(res?.items?.length){
        this.setButton('checkout')
        res.items.sort((a,b) => {
          if(a.handle.includes('membership') && b.handle.includes('membership')) {
            return 0
          }
          if(a.handle.includes('membership') && !b.handle.includes('membership')){
            return 1
          }
          if(!a.handle.includes('membership') && b.handle.includes('membership')){
            return -1
          }
        }).forEach(({id, image, product_title, options_with_values, price, handle, quantity}) => {
          const itemEl = this.createCartItem({id, image, title: product_title, options: options_with_values, price, handle, quantity})
          itemEl.style.opacity = '0'
          this.itemsContainerEl.append(itemEl)
          forceLayout()
          requestAnimationFrame(()=>{
            itemEl.style.opacity = ''
            itemEl.style.transition = 'all .1s var(--ease)'
          })
        })
      } else {
        this.setButton('buy')
        const emptyMessageEl =  ce({classname: 'cart-popup__empty-message', contents: 'Nothing here yet!'})
        this.itemsContainerEl.append(emptyMessageEl)
      }

      this.subtotalValueEl.innerHTML = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(res.items_subtotal_price/100)
      updateTabbableEls(this.popupEl)
    })
    .catch(err => {
      this.setIsLoading(false)
      console.log(err)
    })
  }

  open(focusOnCloseEl, numItems = 2) {
    clearTimeout(this.timeout)
    this.setError(false)
    this.refresh()
    this.focusOnCloseEl = focusOnCloseEl
    this.isOpen = true
    this.popupEl.style.setProperty('--num-items', numItems)
    this.append(this.overlay)
    this.append(this.popupEl)
    forceLayout()
    requestAnimationFrame(()=>{
      this.overlay.classList.add('is-open')
      this.popupEl.classList.add('is-open')
      trapFocus(this.popupEl)
    })
    document.addEventListener('click',(evt)=>{
      if(!this.contains(evt.target)){
        this.close()
      }
    })
  }

  close(focusEl) {
    clearTimeout(this.timeout)
    if(focusEl) this.focusOnCloseEl = focusEl
    if(this.focusOnCloseEl) this.focusOnCloseEl.focus()
    this.isOpen = false
    this.popupEl.classList.remove('is-open')
    this.overlay.classList.remove('is-open')

    this.timeout = setTimeout(() => {
      this.popupEl.remove()
      this.overlay.remove()
    }, 300)
  }

  toggle(focusEl = null){
    if(this.isOpen) { 
      this.close(focusEl)
    } else {
      this.open(focusEl)
    }
  }

}
customElements.define('cart-popup', CartPopup);
